import { useWatch } from 'react-hook-form';

import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { VisitMedicalServiceTableBean } from '../../shared/medicalServices/medicalServices.types';
import { visitSettlementTranslationKeys } from '../../translations';
import { VisitSettlementControl } from '../../visitSettlement.types';

type VisitSettlementFormTabLabelProps = {
   readonly control: VisitSettlementControl;
};

export const VisitSettlementFormTabLabel = (props: VisitSettlementFormTabLabelProps): JSX.Element => {
   const visitMedicalServices = useWatch<VisitMedicalServiceTableBean[]>({
      name: 'visitSettlement.medicalServices',
      control: props.control,
      defaultValue: [],
   });

   return (
      <Translate>
         {createInterpolatedTranslationKey(visitSettlementTranslationKeys.extensions.visitForm.formTabLabel, {
            count: visitMedicalServices.length,
         })}
      </Translate>
   );
};
